module.exports = __webpack_public_path__ + "media/images/background/login-register2-d59cd4b247de1b144da45a5c81e5ac28.jpg";